import { Footer } from '../components';
import { FC } from 'react';

const Skeleton: FC = ({ children }) => {
  return <div className='skeleton-wrapper'>{children}</div>;
};

export default Skeleton;
